import React, {Component} from 'react';

import './styles.scss';

class Comment extends Component {

    render() {
        return (
            <div className={"comment"} style={{width:this.props.width, marginTop:this.props.margin}}> {this.props.children}</div>
        );
    }
}

export default Comment;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/common/comment/Comment.js